import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const CTA_BOOK_ONLINE_SVG = 'https://cdn.magicpatterns.com/uploads/e3r1rj47crZgXHRpz1A67c/sj-website-cta-book-online.svg';
export function WhyChooseUsSection() {
  return <section className="bg-light py-24 md:py-32 relative z-20" data-id="element-319">
      <div className="container mx-auto px-6 md:px-12" data-id="element-320">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-321">
          {/* Left Heading */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-4" data-id="element-322">
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-heading font-bold text-primary uppercase leading-[0.85] tracking-tighter mb-8 lg:mb-0" data-id="element-323">
              Why <br data-id="element-324" /> Choose <br data-id="element-325" /> Us?
            </h2>
          </motion.div>

          {/* Right Image & Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="lg:col-span-8 relative" data-id="element-326">
            <div className="h-[500px] md:h-[600px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-327">
              <img src="https://cdn.magicpatterns.com/uploads/fvLGuhK8ZtKCcr8Dpv4hcg/sj-website-why-choose-us.png" alt="Spotless home after professional cleaning by Smith & Jengs" loading="lazy" className="w-full h-full object-cover" data-id="element-328" />
            </div>

            {/* Floating Info Card */}
            <div className="absolute -bottom-12 left-6 md:left-12 right-6 md:right-auto md:w-[500px] bg-[#2A6B7C] text-white p-8 md:p-12 rounded-2xl shadow-2xl z-10" data-id="element-329">
              <p className="text-lg leading-relaxed mb-8 font-light" data-id="element-330">
                We deliver an outstanding service backed by our 100%
                satisfaction guarantee. Our team is professional, experienced,
                and insured. You won't have to worry about home cleaning or
                commercial cleaning again, and have more time for what matters
                most to you.
              </p>

              <div className="flex items-center justify-between border-t border-white/20 pt-8" data-id="element-331">
                <div className="text-sm text-white/60" data-id="element-332">
                  <p data-id="element-333">Fully Insured & Vetted</p>
                  <p data-id="element-334">100% Satisfaction Guarantee</p>
                </div>

                <Link to="/services" className="hover:opacity-80 transition-opacity" data-id="element-335">
                  <img src={CTA_BOOK_ONLINE_SVG} alt="Book Online" className="h-10 md:h-12" data-id="element-336" />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}